import { LinkOutlined } from '@ant-design/icons';
import { AppModal, DefaultCopyBox, SecondaryButton, styleVariables } from '@lib/common';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ModalTitle = styled.div.withConfig({
  displayName: "share-publish-score-result-modalcomponent__ModalTitle",
  componentId: "sc-3j97n0-0"
})(["display:flex;align-items:center;gap:12px;font-size:20px;line-height:28px;font-weight:600;"]);
var TitleIcon = styled.span.withConfig({
  displayName: "share-publish-score-result-modalcomponent__TitleIcon",
  componentId: "sc-3j97n0-1"
})(["display:inline-flex;flex:0 0 36px;align-items:center;justify-content:center;width:36px;height:36px;color:", ";background:", ";border-radius:10px;"], styleVariables.colors.blue2, styleVariables.colors.blue1);
var StyledDescription = styled.span.withConfig({
  displayName: "share-publish-score-result-modalcomponent__StyledDescription",
  componentId: "sc-3j97n0-2"
})(["display:block;margin-bottom:18px;color:", ";font-size:14px;line-height:22px;"], styleVariables.colors.gray11);
var ShareLinkCard = styled.div.withConfig({
  displayName: "share-publish-score-result-modalcomponent__ShareLinkCard",
  componentId: "sc-3j97n0-3"
})(["padding:14px;background:", ";border:1px solid ", ";border-radius:12px;.ant-input{width:calc(100% - 52px) !important;min-width:0;color:", " !important;background:", " !important;text-overflow:ellipsis;}.ant-btn{width:52px !important;}"], styleVariables.colors.gray2, styleVariables.colors.primary20, styleVariables.colors.gray12, styleVariables.colors.gray1);
var ShareLinkLabel = styled.div.withConfig({
  displayName: "share-publish-score-result-modalcomponent__ShareLinkLabel",
  componentId: "sc-3j97n0-4"
})(["margin-bottom:8px;color:", ";font-size:13px;line-height:20px;font-weight:600;"], styleVariables.colors.gray12);
var QrBlock = styled.div.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrBlock",
  componentId: "sc-3j97n0-5"
})(["display:flex;flex-direction:column;align-items:center;gap:14px;margin-top:16px;padding:20px;background:", ";border:1px solid ", ";border-radius:12px;"], styleVariables.colors.gray2, styleVariables.colors.gray6);
var QrHint = styled.span.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrHint",
  componentId: "sc-3j97n0-6"
})(["color:", ";font-size:13px;line-height:20px;text-align:center;"], styleVariables.colors.gray11);
var QrFrame = styled.div.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrFrame",
  componentId: "sc-3j97n0-7"
})(["padding:12px;background:", ";border:1px solid ", ";border-radius:12px;box-shadow:0 4px 12px rgb(28 30 32 / 8%);"], styleVariables.colors.gray1, styleVariables.colors.gray5);
var QrImage = styled.img.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrImage",
  componentId: "sc-3j97n0-8"
})(["display:block;width:220px;height:220px;@media (max-width:600px){width:180px;height:180px;}"]);
export var SharePublishScoreResultModal = function SharePublishScoreResultModal(props) {
  var isModalVisible = props.isModalVisible,
      sharedLink = props.sharedLink,
      absoluteShareUrl = props.absoluteShareUrl,
      onClose = props.onClose,
      label = props.label;
  var urlToCopy = absoluteShareUrl !== null && absoluteShareUrl !== void 0 ? absoluteShareUrl : sharedLink;
  var copyBoxTranslation = {
    copy: label.copy,
    copied: label.copied
  };
  var qrSrc = absoluteShareUrl && "https://api.qrserver.com/v1/create-qr-code/?size=440x440&data=".concat(encodeURIComponent(absoluteShareUrl));

  var renderSharePublishScoreResultContent = function renderSharePublishScoreResultContent() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledDescription, {
        children: label.description
      }), /*#__PURE__*/_jsxs(ShareLinkCard, {
        children: [/*#__PURE__*/_jsx(ShareLinkLabel, {
          children: label.linkLabel
        }), /*#__PURE__*/_jsx(DefaultCopyBox, {
          text: urlToCopy,
          copyBoxTranslation: copyBoxTranslation
        })]
      }), qrSrc && /*#__PURE__*/_jsxs(QrBlock, {
        children: [label.qrCodeHint ? /*#__PURE__*/_jsx(QrHint, {
          children: label.qrCodeHint
        }) : null, /*#__PURE__*/_jsx(QrFrame, {
          children: /*#__PURE__*/_jsx(QrImage, {
            src: qrSrc,
            alt: label.qrCodeAlt
          })
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsx(AppModal, {
    width: 640,
    centered: true,
    title: /*#__PURE__*/_jsxs(ModalTitle, {
      children: [/*#__PURE__*/_jsx(TitleIcon, {
        children: /*#__PURE__*/_jsx(LinkOutlined, {})
      }), label.title]
    }),
    open: isModalVisible,
    onCancel: onClose,
    footer: /*#__PURE__*/_jsx(SecondaryButton, {
      onClick: onClose,
      children: label.close
    }),
    children: renderSharePublishScoreResultContent()
  });
};